//  Cricket constants declaration				
const CricketLand = 6.8;
const CricketWater = 0.453592370010035;
const CricketGHG = 0.453592370010035;

//  Beef constants declaration
const BeefLand = 90.7184740020071;
const BeefWater = 9979.03214022078;
const BeefGHG = 1292.7382545286;

//  Chicken constants declaration
const ChickenLand = 20.4116566504516;
const ChickenWater = 1043.26245102308;
const ChickenGHG = 136.077711003011;

//  Pig/Other constants declaration
const PigLand = 22.6796185005018;
const PigWater = 1542.21199625062;
const PigGHG = 512.55731632784;

// Protein per year (lbs). Depends on how manny cups you feed a day. The calculation is made with 1 cup per day.
let dog;
function WhatDog(dog) {
  //document.getElementById('dogSizeFinal').innerHTML=dog.toUpperCase();
}

let theDogName;
function dogsName(theDogName) {
  document.getElementById('dogsName').innerHTML = theDogName;
}

//let ProteinPerYear;
let protein;
function EcoCalcFor(proteinType) {
  //  document.getElementById('proteinFedFinal').innerHTML=proteinType.toUpperCase();
  return proteinType;
}
let cups = 0;
function cupsADay(howManyCups) {
  // console.log(howManyCups);
  //   setTimeout(() => {
  //    document.getElementById('cupsFedFinal').innerHTML=howManyCups;
  //  }, 500);

  let ProteinPerYear = ((howManyCups * 365) / 2) * 0.3;
  //  console.log('ProteinPerYear:', ProteinPerYear);
  switch (protein) {
    case 'beef':
      CricketvsBeef(ProteinPerYear);
      break;
    case 'chicken':
      CricketvsChicken(ProteinPerYear);
      break;
    case 'other':
      CricketvsPig(ProteinPerYear);
      break;
  }
}
cupsADay();

function CricketvsBeef(ProteinPerYear) {

  let CricketLandYear = CricketLand * ProteinPerYear;
  let CricketWaterYear = CricketWater * ProteinPerYear;
  let CricketGHGYear = CricketGHG * ProteinPerYear;

  let BeefLandYear = BeefLand * ProteinPerYear;
  let BeefWaterYear = BeefWater * ProteinPerYear;
  let BeefGHGYear = BeefGHG * ProteinPerYear;

  let Cricket_vs_Beef_Acres = (BeefLandYear - CricketLandYear) * 0.00025;
  let Cricket_vs_Beef_Trees = Cricket_vs_Beef_Acres * 450;
  let Cricket_vs_Beef_Galoons_of_Water = (BeefWaterYear - CricketWaterYear) * 0.264;
  let Cricket_vs_Beef_Toilet_Flushes = Cricket_vs_Beef_Galoons_of_Water / 1.5;
  let Cricket_vs_Beef_GHG = (BeefGHGYear - CricketGHGYear);
  let Cricket_vs_Beef_Miles_Not_Driven = Cricket_vs_Beef_GHG / 1000 / 8.887 * 25;


  setTimeout(function () {
    landSavings.innerHTML = Math.round(Cricket_vs_Beef_Acres);
    waterSavings.innerHTML = Math.round(Cricket_vs_Beef_Galoons_of_Water);
    ghgSavings.innerHTML = Math.round(Cricket_vs_Beef_GHG);
    treeSavings.innerHTML = Math.round(Cricket_vs_Beef_Trees);
    flushSavings.innerHTML = Math.round(Cricket_vs_Beef_Toilet_Flushes);
    milesSavings.innerHTML = Math.round(Cricket_vs_Beef_Miles_Not_Driven);
  }, 1000);

}

function CricketvsChicken(ProteinPerYear) {
  let CricketLandYear = CricketLand * ProteinPerYear;
  let CricketWaterYear = CricketWater * ProteinPerYear;
  let CricketGHGYear = CricketGHG * ProteinPerYear;

  let ChickenLandYear = ChickenLand * ProteinPerYear;
  let ChickenWaterYear = ChickenWater * ProteinPerYear;
  let ChickenGHGYear = ChickenGHG * ProteinPerYear;

  let Cricket_vs_Chicken_Acres = (ChickenLandYear - CricketLandYear) * 0.00025;
  let Cricket_vs_Chicken_Trees = Cricket_vs_Chicken_Acres * 450;
  let Cricket_vs_Chicken_Galoons_of_Water = (ChickenWaterYear - CricketWaterYear) * 0.264;
  let Cricket_vs_Chicken_Toilet_Flushes = Cricket_vs_Chicken_Galoons_of_Water / 1.5;
  let Cricket_vs_Chicken_GHG = (ChickenGHGYear - CricketGHGYear);
  let Cricket_vs_Chicken_Miles_Not_Driven = Cricket_vs_Chicken_GHG / 1000 / 8.887 * 25;

  setTimeout(function () {
    document.getElementById('landSavings').innerHTML = Math.round(Cricket_vs_Chicken_Acres);
    document.getElementById('waterSavings').innerHTML = Math.round(Cricket_vs_Chicken_Galoons_of_Water);
    document.getElementById('ghgSavings').innerHTML = Math.round(Cricket_vs_Chicken_GHG);
    document.getElementById('treeSavings').innerHTML = Math.round(Cricket_vs_Chicken_Trees);
    document.getElementById('flushSavings').innerHTML = Math.round(Cricket_vs_Chicken_Toilet_Flushes);
    document.getElementById('milesSavings').innerHTML = Math.round(Cricket_vs_Chicken_Miles_Not_Driven);
  }, 1000);
}

function CricketvsPig(ProteinPerYear) {
  let CricketLandYear = CricketLand * ProteinPerYear;
  let CricketWaterYear = CricketWater * ProteinPerYear;
  let CricketGHGYear = CricketGHG * ProteinPerYear;

  let PigLandYear = PigLand * ProteinPerYear;
  let PigWaterYear = PigWater * ProteinPerYear;
  let PigGHGYear = PigGHG * ProteinPerYear;

  let Cricket_vs_Pig_Acres = (PigLandYear - CricketLandYear) * 0.00025;
  let Cricket_vs_Pig_Trees = Cricket_vs_Pig_Acres * 450;
  let Cricket_vs_Pig_Galoons_of_Water = (PigWaterYear - CricketWaterYear) * 0.264;
  let Cricket_vs_Pig_Toilet_Flushes = Cricket_vs_Pig_Galoons_of_Water / 1.5;
  let Cricket_vs_Pig_GHG = (PigGHGYear - CricketGHGYear);
  let Cricket_vs_Pig_Miles_Not_Driven = Cricket_vs_Pig_GHG / 1000 / 8.887 * 25;

  setTimeout(function () {
    document.getElementById('landSavings').innerHTML = Math.round(Cricket_vs_Pig_Acres);
    document.getElementById('waterSavings').innerHTML = Math.round(Cricket_vs_Pig_Galoons_of_Water);
    document.getElementById('ghgSavings').innerHTML = Math.round(Cricket_vs_Pig_GHG);
    document.getElementById('treeSavings').innerHTML = Math.round(Cricket_vs_Pig_Trees);
    document.getElementById('flushSavings').innerHTML = Math.round(Cricket_vs_Pig_Toilet_Flushes);
    document.getElementById('milesSavings').innerHTML = Math.round(Cricket_vs_Pig_Miles_Not_Driven);
  }, 1000);
}

// scroll to nav after select option on mobile
function scrollToNext() {
  var w = document.documentElement.clientWidth || window.innerWidth;
  if (w <= 767) {
    const ecoNav = document.getElementsByClassName('ecoNav');
    let i;
    for (i = 0; i < ecoNav.length; i++) {
      if (ecoNav[i] instanceof HTMLElement) {
        ecoNav[i].scrollIntoView();
      }
    }
  }
}
document.addEventListener("DOMContentLoaded", function () {
  const swiper = new Swiper('.ecoCalcSwipe', {
    autoplay: {
      delay: 16000,
    },
    loop: true,
    spaceBetween: 30,
    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next1',
      prevEl: '.swiper-button-prev1',
    },
  });
});


function resetSelect() {
  document.getElementById("assigned-to-option-1").click();
  // document.getElementById("xxl-dog").style.borderColor = "#d5d9dc";
  // document.getElementById("big-dog").style.borderColor = "#d5d9dc";
  // document.getElementById("medium-dog").style.borderColor = "#d5d9dc";
  // document.getElementById("small-dog").style.borderColor = "#d5d9dc";
  // document.getElementById("petit-dog").style.borderColor = "#d5d9dc";
}

function xxlDogAddGreenBorder() {
  document.getElementById("xxl-dog").style.borderColor = "#95c940";
  document.getElementById("xxl-dog").style.borderWidth = "4px";
  document.getElementById("big-dog").style.borderColor = "#d5d9dc";
  document.getElementById("big-dog").style.borderWidth = "2px";
  document.getElementById("medium-dog").style.borderColor = "#d5d9dc";
  document.getElementById("medium-dog").style.borderWidth = "2px";
  document.getElementById("small-dog").style.borderColor = "#d5d9dc";
  document.getElementById("small-dog").style.borderWidth = "2px";
  document.getElementById("petit-dog").style.borderColor = "#d5d9dc";
  document.getElementById("petit-dog").style.borderWidth = "2px";
}

function bigDogAddGreenBorder() {
  document.getElementById("xxl-dog").style.borderColor = "#d5d9dc";
  document.getElementById("xxl-dog").style.borderWidth = "2px";
  document.getElementById("big-dog").style.borderColor = "#95c940";
  document.getElementById("big-dog").style.borderWidth = "4px";
  document.getElementById("medium-dog").style.borderColor = "#d5d9dc";
  document.getElementById("medium-dog").style.borderWidth = "2px";
  document.getElementById("small-dog").style.borderColor = "#d5d9dc";
  document.getElementById("small-dog").style.borderWidth = "2px";
  document.getElementById("petit-dog").style.borderColor = "#d5d9dc";
  document.getElementById("petit-dog").style.borderWidth = "2px";
}
function mediumDogAddGreenBorder() {
  document.getElementById("xxl-dog").style.borderColor = "#d5d9dc";
  document.getElementById("xxl-dog").style.borderWidth = "2px";
  document.getElementById("big-dog").style.borderColor = "#d5d9dc";
  document.getElementById("big-dog").style.borderWidth = "2px";
  document.getElementById("medium-dog").style.borderColor = "#95c940";
  document.getElementById("medium-dog").style.borderWidth = "4px";
  document.getElementById("small-dog").style.borderColor = "#d5d9dc";
  document.getElementById("small-dog").style.borderWidth = "2px";
  document.getElementById("petit-dog").style.borderColor = "#d5d9dc";
  document.getElementById("petit-dog").style.borderWidth = "2px";
}
function smallDogAddGreenBorder() {
  document.getElementById("xxl-dog").style.borderColor = "#d5d9dc";
  document.getElementById("xxl-dog").style.borderWidth = "2px";
  document.getElementById("big-dog").style.borderColor = "#d5d9dc";
  document.getElementById("big-dog").style.borderWidth = "2px";
  document.getElementById("medium-dog").style.borderColor = "#d5d9dc";
  document.getElementById("medium-dog").style.borderWidth = "2px";
  document.getElementById("small-dog").style.borderColor = "#95c940";
  document.getElementById("small-dog").style.borderWidth = "4px";
  document.getElementById("petit-dog").style.borderColor = "#d5d9dc";
  document.getElementById("petit-dog").style.borderWidth = "2px";
}
function petitDogAddGreenBorder() {
  document.getElementById("xxl-dog").style.borderColor = "#d5d9dc";
  document.getElementById("xxl-dog").style.borderWidth = "2px";
  document.getElementById("big-dog").style.borderColor = "#d5d9dc";
  document.getElementById("big-dog").style.borderWidth = "2px";
  document.getElementById("medium-dog").style.borderColor = "#d5d9dc";
  document.getElementById("medium-dog").style.borderWidth = "2px";
  document.getElementById("small-dog").style.borderColor = "#d5d9dc";
  document.getElementById("small-dog").style.borderWidth = "2px";
  document.getElementById("petit-dog").style.borderColor = "#95c940";
  document.getElementById("petit-dog").style.borderWidth = "4px";
}

function resetBorders() {
  document.getElementById("xxl-dog").style.borderColor = "#d5d9dc";
  document.getElementById("big-dog").style.borderColor = "#d5d9dc";
  document.getElementById("medium-dog").style.borderColor = "#d5d9dc";
  document.getElementById("small-dog").style.borderColor = "#d5d9dc";
  document.getElementById("petit-dog").style.borderColor = "#d5d9dc";
  document.getElementById("protein-other").style.borderColor = "#d5d9dc";
  document.getElementById("protein-beef").style.borderColor = "#d5d9dc";
  document.getElementById("protein-chicken").style.borderColor = "#d5d9dc";
  document.getElementById("xxl-dog").style.borderWidth = "2px";
  document.getElementById("big-dog").style.borderWidth = "2px";
  document.getElementById("medium-dog").style.borderWidth = "2px";
  document.getElementById("small-dog").style.borderWidth = "2px";
  document.getElementById("petit-dog").style.borderWidth = "2px";
  document.getElementById("protein-other").style.borderWidth = "2px";
  document.getElementById("protein-beef").style.borderWidth = "2px";
  document.getElementById("protein-chicken").style.borderWidth = "2px";
}

function proteinOtherAddGreenBorder() {
  document.getElementById("protein-other").style.borderColor = "#95c940";
  document.getElementById("protein-beef").style.borderColor = "#d5d9dc";
  document.getElementById("protein-chicken").style.borderColor = "#d5d9dc";
  document.getElementById("protein-other").style.borderWidth = "4px";
  document.getElementById("protein-beef").style.borderWidth = "2px";
  document.getElementById("protein-chicken").style.borderWidth = "2px";
}
function proteinBeefAddGreenBorder() {
  document.getElementById("protein-other").style.borderColor = "#d5d9dc";
  document.getElementById("protein-beef").style.borderColor = "#95c940";
  document.getElementById("protein-chicken").style.borderColor = "#d5d9dc";
  document.getElementById("protein-other").style.borderWidth = "2px";
  document.getElementById("protein-beef").style.borderWidth = "4px";
  document.getElementById("protein-chicken").style.borderWidth = "2px";
}
function proteinChickenAddGreenBorder() {
  document.getElementById("protein-other").style.borderColor = "#d5d9dc";
  document.getElementById("protein-beef").style.borderColor = "#d5d9dc";
  document.getElementById("protein-chicken").style.borderColor = "#95c940";
  document.getElementById("protein-other").style.borderWidth = "2px";
  document.getElementById("protein-beef").style.borderWidth = "2px";
  document.getElementById("protein-chicken").style.borderWidth = "4px";
}

//references

                    // PROTEIN (lbs) / YEAR 		
/*
//  Cricket value protein per year calculation				
let CricketLandYear=CricketLand*ProteinPerYear; console.log('CricketLandYear:', CricketLandYear);
let CricketWaterYear=CricketWater*ProteinPerYear; console.log('CricketWaterYear:', CricketWaterYear);
let CricketGHGYear=CricketGHG*ProteinPerYear; console.log('CricketGHGYear:', CricketGHGYear);

//  Beef value protein per year calculation
let BeefLandYear=BeefLand*ProteinPerYear; console.log('BeefLandYear:', BeefLandYear);
let BeefWaterYear=BeefWater*ProteinPerYear; console.log('BeefWaterYear:', BeefWaterYear);
let BeefGHGYear=BeefGHG*ProteinPerYear; console.log('BeefGHGYear:', BeefGHGYear);

//  Chicken value protein per year calculation
let ChickenLandYear=ChickenLand*ProteinPerYear; console.log('ChickenLandYear:', ChickenLandYear);
let ChickenWaterYear=ChickenWater*ProteinPerYear; console.log('ChickenWaterYear:', ChickenWaterYear);
let ChickenGHGYear=ChickenGHG*ProteinPerYear; console.log('ChickenGHGYear:', ChickenGHGYear);

//  Pig/Other value protein per year calculation
let PigLandYear=PigLand*ProteinPerYear; console.log('PigLandYear:', PigLandYear);
let PigWaterYear=PigWater*ProteinPerYear; console.log('PigWaterYear:', PigWaterYear);
let PigGHGYear=PigGHG*ProteinPerYear; console.log('PigGHGYear:', PigGHGYear);

                    
// OUTPUT RESULTS

                   // CRICKET VS. BEEF	COMPARATION

 let Cricket_vs_Beef_Acres=(BeefLandYear-CricketLandYear)*0.00025;  console.log('Cricket_vs_Beef_Acres:', Math.round(Cricket_vs_Beef_Acres));
 let Cricket_vs_Beef_Trees=Cricket_vs_Beef_Acres*450;  console.log('Cricket_vs_Beef_Trees:', Math.round(Cricket_vs_Beef_Trees));
 let Cricket_vs_Beef_Galoons_of_Water=(BeefWaterYear-CricketWaterYear)*0.264; console.log('Cricket_vs_Beef_Galoons_of_Water:', Math.round(Cricket_vs_Beef_Galoons_of_Water));
 let Cricket_vs_Beef_Toilet_Flushes=Cricket_vs_Beef_Galoons_of_Water/1.5; console.log('Cricket_vs_Beef_Toilet_Flushes:', Math.round(Cricket_vs_Beef_Toilet_Flushes));
 let Cricket_vs_Beef_GHG=(BeefGHGYear-CricketGHGYear); console.log('Cricket_vs_Beef_GHG:', Math.round(Cricket_vs_Beef_GHG));
 let Cricket_vs_Beef_Miles_Not_Driven=Cricket_vs_Beef_GHG/1000/8.887*25; console.log('Cricket_vs_Beef_Miles_Not_Driven:', Math.round(Cricket_vs_Beef_Miles_Not_Driven));



                  // CRICKET VS. CHICKEN	COMPARATION

 let Cricket_vs_Chicken_Acres=(ChickenLandYear-CricketLandYear)*0.00025;  console.log('Cricket_vs_Chicken_Acres:', Math.round(Cricket_vs_Chicken_Acres));
 let Cricket_vs_Chicken_Trees=Cricket_vs_Chicken_Acres*450;  console.log('Cricket_vs_Chicken_Trees:', Math.round(Cricket_vs_Chicken_Trees));
 let Cricket_vs_Chicken_Galoons_of_Water=(ChickenWaterYear-CricketWaterYear)*0.264; console.log('Cricket_vs_Chicken_Galoons_of_Water:', Math.round(Cricket_vs_Chicken_Galoons_of_Water));
 let Cricket_vs_Chicken_Toilet_Flushes=Cricket_vs_Chicken_Galoons_of_Water/1.5; console.log('Cricket_vs_Chicken_Toilet_Flushes:', Math.round(Cricket_vs_Chicken_Toilet_Flushes));
 let Cricket_vs_Chicken_GHG=(ChickenGHGYear-CricketGHGYear); console.log('Cricket_vs_Chicken_GHG:', Math.round(Cricket_vs_Chicken_GHG));
 let Cricket_vs_Chicken_Miles_Not_Driven=Cricket_vs_Chicken_GHG/1000/8.887*25; console.log('Cricket_vs_Chicken_Miles_Not_Driven:', Math.round(Cricket_vs_Chicken_Miles_Not_Driven));

 

                  // CRICKET VS. PIG / OTHER	COMPARATION

 let Cricket_vs_Pig_Acres=(PigLandYear-CricketLandYear)*0.00025;  console.log('Cricket_vs_Pig_Acres:', Math.round(Cricket_vs_Pig_Acres));
 let Cricket_vs_Pig_Trees=Cricket_vs_Pig_Acres*450;  console.log('Cricket_vs_Pig_Trees:', Math.round(Cricket_vs_Pig_Trees));
 let Cricket_vs_Pig_Galoons_of_Water=(PigWaterYear-CricketWaterYear)*0.264; console.log('Cricket_vs_Pig_Galoons_of_Water:', Math.round(Cricket_vs_Pig_Galoons_of_Water));
 let Cricket_vs_Pig_Toilet_Flushes=Cricket_vs_Pig_Galoons_of_Water/1.5; console.log('Cricket_vs_Pig_Toilet_Flushes:', Math.round(Cricket_vs_Pig_Toilet_Flushes));
 let Cricket_vs_Pig_GHG=(PigGHGYear-CricketGHGYear); console.log('Cricket_vs_Pig_GHG:', Math.round(Cricket_vs_Pig_GHG));
 let Cricket_vs_Pig_Miles_Not_Driven=Cricket_vs_Pig_GHG/1000/8.887*25; console.log('Cricket_vs_Pig_Miles_Not_Driven:', Math.round(Cricket_vs_Pig_Miles_Not_Driven));

 */
